import React from 'react';

import { ICONS } from 'shared/presentation/constants';
import {
  TRoutePathsWithParams,
  useLocale,
  useNavigation,
} from 'shared/presentation/contexts';

import * as S from './styles';

const BackIcon = ICONS.ARROW_LEFT;

interface IBackButtonProps {
  text?: string;
  to?: TRoutePathsWithParams;
  onClick?: () => void;
}

const BackButton: React.FC<IBackButtonProps> = ({ text, to, onClick }) => {
  const navigation = useNavigation();
  const { t } = useLocale('customer');

  const handleGoBack = () => {
    onClick?.();

    if (to) return navigation.replace(to);

    return navigation.goBack();
  };

  return (
    <S.Container onClick={handleGoBack}>
      <BackIcon />

      <span>{text || t('Back')}</span>
    </S.Container>
  );
};

export default BackButton;
